var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.73,
    viewBox: "0 0 24 21.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45,21.73h0A1,1,0,0,1,.48,21c0-.19-.09-.38-.13-.56A12.44,12.44,0,0,1,0,16.64a12.62,12.62,0,0,1,.85-3.82A12,12,0,0,1,2.81,9.68,10.86,10.86,0,0,1,5.52,7.27,13.16,13.16,0,0,1,9.32,5.7a13.58,13.58,0,0,1,1.55-.25V1a1,1,0,0,1,.56-.9,1,1,0,0,1,1.06.12L23.62,9a1,1,0,0,1,0,1.57l-11.13,8.8a1,1,0,0,1-1.06.12,1,1,0,0,1-.56-.9V14.13l-.32,0a10.37,10.37,0,0,0-2.43.66,9,9,0,0,0-2.51,1.5A10.67,10.67,0,0,0,3.19,19.2a12.22,12.22,0,0,0-.79,1.85A1,1,0,0,1,1.45,21.73ZM12.87,3.07V6.38a1,1,0,0,1-.95,1,11.32,11.32,0,0,0-2.15.27A11.15,11.15,0,0,0,6.58,9a8.91,8.91,0,0,0-2.23,2,10.09,10.09,0,0,0-1.62,2.62A10.85,10.85,0,0,0,2,16.77c0,.19,0,.38,0,.56a13.27,13.27,0,0,1,2.33-2.54,11,11,0,0,1,3-1.82,11.88,11.88,0,0,1,2.91-.78,10.15,10.15,0,0,1,1.6-.09,1,1,0,0,1,1,1v3.44L21.39,9.8Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.503154d52364e8bf58aa6160440b5000.svg";
export { ForwardRef as ReactComponent };